import { Box, Text, VStack } from '@chakra-ui/react';

export type RosterIssue = { label: string; reason: string; rowIndex?: number };

const RosterErrorSummary = ({ issues, afterInvite = false }: { issues: RosterIssue[]; afterInvite?: boolean }) => {
  if (issues.length === 0) return null;

  return (
    <Box
      role="alert"
      width="610px"
      maxWidth="100%"
      marginX="auto"
      padding="16px"
      border="2px solid #ef4444"
      borderRadius="20px"
      backgroundColor="#fff4f2"
      fontFamily="Urbanist"
      fontSize="12px"
      fontWeight={500}
    >
      <Text color="#d94141" fontSize="14px" fontWeight={700}>
        {afterInvite
          ? `${issues.length} ${issues.length === 1 ? 'row was' : 'rows were'} not invited`
          : `${issues.length} ${issues.length === 1 ? 'row needs' : 'rows need'} attention before you can continue`}
      </Text>
      <VStack as="ul" align="stretch" spacing="8px" listStyleType="none" margin={0} padding={0}>
        {issues.map((issue, index) => (
          <Box as="li" key={index} color="text.darkBlue" fontSize="14px" fontWeight={500} lineHeight="1.25">
            {issue.rowIndex !== undefined && Number.isInteger(issue.rowIndex) && issue.rowIndex >= 0 && (
              <>Row {issue.rowIndex + 1}: </>
            )}
            <Text as="span" fontWeight={700}>
              {issue.label}
            </Text>{' '}
            - {issue.reason}
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default RosterErrorSummary;
